var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPilotPhysicist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 280",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#fff;}.cls-3{fill:#b7b7b7;}.cls-4{fill:#e5e5e5;}.cls-5{fill:#0f0f0f;}.cls-6{fill:#ff4800;}.cls-7{fill:#1c1a18;}.cls-8{fill:#6cfffb;opacity:0.5;}.cls-8,.cls-9{mix-blend-mode:hard-light;}.cls-10{fill:#333;}.cls-11{fill:#00fff2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "182.95 176.53 97.05 176.53 41.42 205.29 32.91 284.74 247.09 284.74 238.58 205.29 182.95 176.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "161.4 291.44 117.46 291.44 103.1 175.69 175.76 176.53 161.4 291.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "110.7 229.76 74.37 237.36 80.29 182.44 102.26 174 110.7 229.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "167.96 229.77 204.29 237.38 198.37 182.46 176.4 174.01 167.96 229.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "159.8 302.28 175.86 285.38 189.08 247.51 168.25 229.62 159.8 302.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "151.95 308.33 128.6 308.33 132.43 216.24 148.12 216.24 151.95 308.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "152.1 222.84 140.28 226.38 128.45 222.84 105.64 188.78 40.58 150.34 97.74 116.54 175.03 116.54 239.97 150.34 174.92 188.78 152.1 222.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "222.82 25.6 218.59 18 159.66 54.58 121.67 54.58 62.55 18.22 58.32 25.83 64.53 85.02 41 148.42 97.45 144.76 120.18 146.97 130.66 199.72 150.68 199.72 160.99 146.97 183.18 144.76 240.33 148.42 217.16 84.97 222.82 25.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "182.73 146.69 160.55 148.65 163.5 132.94 199.42 125.77 182.73 146.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "140.7 210.42 130.74 201.46 140.7 198.25 150.66 201.46 140.7 210.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "98.48 146.9 120.66 148.87 117.71 133.16 84.33 125.99 98.48 146.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "58.32 27.83 64.2 86.17 85.36 68.38 58.32 27.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "222.82 27.6 216.94 85.94 195.78 68.16 222.82 27.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "118.86 302.27 102.8 285.37 89.58 247.5 110.41 229.6 118.86 302.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "236.59 135.97 233.22 125.84 213.82 125.84 214.21 108.09 68.92 108.13 68.93 125.84 48.18 125.84 44.8 135.97 68.94 135.97 68.95 157.64 73.06 164.39 123.66 164.39 135.02 157.64 146.9 157.61 159.46 164.36 210.06 164.36 212.97 157.61 213.55 135.97 236.59 135.97"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M209,113.16l-.28,12.57-.11,5.18h0l-.13,4.93-.55,20.66-1.2,2.79h-46l-11.43-6.15-1.13-.6h-1.28l-11.88,0h-1.39l-1.19.71-10.16,6H75.91L74,156.22V130.91h0V113.19l135,0m5.18-5.07-145.29,0v17.72H48.18L44.8,136H68.94v21.66l4.11,6.75h50.6L135,157.64l11.88,0,12.56,6.75h50.6l2.91-6.75.58-21.63h23l-3.37-10.14h-19.4l.39-17.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 77.75,
    y: 116.54,
    width: 15.21,
    height: 5.91
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 97.03,
    y: 116.69,
    width: 5.54,
    height: 5.91
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 106.7,
    y: 116.69,
    width: 11.38,
    height: 5.91
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 77.59,
    y: 126.84,
    width: 5.54,
    height: 5.91
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 87.27,
    y: 126.84,
    width: 11.38,
    height: 5.91
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 51.56,
    y: 242.43,
    width: 34.64,
    height: 2.53
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotPhysicist);
export default __webpack_public_path__ + "static/media/pilot-physicist.5262e159ee5ec8ba15115348e14ba6f7.svg";
export { ForwardRef as ReactComponent };